import { render, staticRenderFns } from "./m-addKeywordChild.vue?vue&type=template&id=131a7c08&"
import script from "./m-addKeywordChild.vue?vue&type=script&lang=js&"
export * from "./m-addKeywordChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports